import { ItemNamePrefix } from "./consts";

export const getTimelineItemClassName = (entityUuid?: string | null) => {
  if (!entityUuid) return;
  return `${ItemNamePrefix.Timeline}_${entityUuid}`;
};

export const getContentItemClassName = (entityUuid?: string | null) => {
  if (!entityUuid) return;
  return `${ItemNamePrefix.Content}_${entityUuid}`;
};

export const makeSureContentItemExists = (entityUuid: string, retry = 5, debounce = 1000) =>
  new Promise<void>(resolve => {
    const run = (currentTime: number, lastTime = 0, _retry = retry) => {
      if (_retry === 0) {
        resolve();
        return;
      }
      if (currentTime - lastTime < debounce) {
        setTimeout(() => {
          requestAnimationFrame(time => run(time, currentTime, _retry));
        }, debounce);
        return;
      }
      if (document.querySelector(`.${getContentItemClassName(entityUuid)}`) === null) {
        requestAnimationFrame(time => run(time, currentTime, _retry - 1));
        return;
      }

      resolve();
    };
    requestAnimationFrame(run);
  });
